"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
var ramda_1 = require("ramda");
var BrandType_1 = require("../types/enums/BrandType");
var LiveStatus_1 = require("../types/enums/LiveStatus");
var graph_ql_1 = require("../types/graph-ql");
var Title_1 = require("./Title");
var utils_1 = require("./utils");
dayjs_1.default.extend(isBetween_1.default);
exports.DEFAULT_SLOT_TITLE = 'Schedule unavailable at this time';
exports.isShow = function (slot) { var _a; return ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === BrandType_1.BrandType.Episode; };
exports.isSport = function (slot) {
    var _a, _b, _c;
    return ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === BrandType_1.BrandType.Episode &&
        ((_c = (_b = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _b === void 0 ? void 0 : _b.show) === null || _c === void 0 ? void 0 : _c.type) === graph_ql_1.ShowType.Sport;
};
exports.isMovie = function (slot) { var _a; return ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === BrandType_1.BrandType.Movie; };
exports.formatRating = function (rating) {
    var _a;
    return ramda_1.isNil(rating === null || rating === void 0 ? void 0 : rating.classification)
        ? ''
        : "" + (rating === null || rating === void 0 ? void 0 : rating.classification.replace(/[^0-9a-z]/gi, '')) + (((_a = rating === null || rating === void 0 ? void 0 : rating.advisories) === null || _a === void 0 ? void 0 : _a.join('')) || '');
};
// The query for slot detail doesn't contain programme.show, as the data is already included in brand.
exports.getSlotTitleWithBrand = function (slot, isSportShow, brandTitle, includeRating, ignoreSeasonAndEpisode) {
    var _a, _b;
    if (ramda_1.isNil(slot)) {
        return '';
    }
    if (ramda_1.isNil(slot.programme)) {
        return exports.DEFAULT_SLOT_TITLE;
    }
    var title;
    if (slot.programme.__typename === BrandType_1.BrandType.Episode && !isSportShow) {
        var seasonNumber = (_a = slot.programme.season) === null || _a === void 0 ? void 0 : _a.number;
        var episodeNumber = slot.programme.number;
        var seasonEpisodeNumber = Title_1.getSeasonEpisodeNumber(seasonNumber, episodeNumber);
        title =
            ramda_1.isEmpty(seasonEpisodeNumber) || ignoreSeasonAndEpisode
                ? brandTitle
                : brandTitle + " " + seasonEpisodeNumber;
    }
    else {
        // Movie & Sport Episode will return episode title
        title = (_b = slot.programme) === null || _b === void 0 ? void 0 : _b.title;
    }
    var rating = exports.formatRating(slot.rating);
    return includeRating && rating ? title + " (" + rating + ")" : title;
};
exports.getSlotTitle = function (slot, includeRating, ignoreSeasonAndEpisode) {
    var _a, _b, _c, _d;
    return exports.getSlotTitleWithBrand(slot, exports.isSport(slot), ((_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.__typename) === BrandType_1.BrandType.Episode
        ? (_c = (_b = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _b === void 0 ? void 0 : _b.show) === null || _c === void 0 ? void 0 : _c.title : (_d = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _d === void 0 ? void 0 : _d.title, includeRating, ignoreSeasonAndEpisode);
};
/**
 * Check slot LIVE status base on on-air status
 * @param slot
 * @param isProd if ENV is PROD, set to 4 hours time frame, otherwise 24 hours
 * @returns is LIVE or LIVE SOON, or no LIVE displaying
 */
exports.getSportLiveStatusByTime = function (slot) {
    if (slot) {
        var live = slot.live, start = slot.start, end = slot.end;
        if (live) {
            var now = dayjs_1.default();
            if (now.isBetween(start, end)) {
                return LiveStatus_1.LiveStatus.LIVE;
            }
            if (dayjs_1.default(start).isBetween(now, now.add(24, 'h'))) {
                return LiveStatus_1.LiveStatus.LIVE_SOON;
            }
            if (dayjs_1.default(start).isAfter(now.add(24, 'h'))) {
                return LiveStatus_1.LiveStatus.LIVE_IN_X_DAYS;
            }
        }
    }
    return LiveStatus_1.LiveStatus.NOT_LIVE;
};
exports.isSlotOnAir = function (slot) {
    if ((slot === null || slot === void 0 ? void 0 : slot.start) && (slot === null || slot === void 0 ? void 0 : slot.end)) {
        var now = dayjs_1.default();
        return now.isBetween(dayjs_1.default(slot.start), dayjs_1.default(slot.end));
    }
    return false;
};
exports.isFinished = function (slot) {
    var now = dayjs_1.default();
    return (slot === null || slot === void 0 ? void 0 : slot.end) && now.isAfter(dayjs_1.default(slot.end));
};
exports.isRecordable = function (slot) {
    return utils_1.isNotNilOrEmpty(slot === null || slot === void 0 ? void 0 : slot.recordOptions) && !exports.isFinished(slot);
};
exports.hasCaptions = function (slot) { return utils_1.isNotNilOrEmpty(slot === null || slot === void 0 ? void 0 : slot.captionLanguages); };
//# sourceMappingURL=Slot.js.map